export default __webpack_public_path__ + "static/media/patientDisplaysAggression.f9666d00.svg";